<template>
  <div class="nanhangLogin">
    <img class="logo" src="@/assets/img/nanhang/title.png" alt="南航" />
    <div class="loginCard">
      <h2 class="title">南航订单查询</h2>
      <p class="subtitle">请输入手机号登录查询订单</p>
      <van-form
        ref="loginForm"
        class="container"
        @submit="onSubmit"
        validate-first
      >
        <van-field
          v-model="form.phone"
          name="phone"
          type="number"
          clearable
          center
          placeholder="手机号码"
          :rules="[
            { required: true, message: '请填写手机号' },
            { pattern: /^1\d{10}$/, message: '请填写正确的手机号' }
          ]"
        />
        <van-field
          v-model="form.captchaCode"
          name="captchaCode"
          center
          clearable
          maxlength="6"
          placeholder="短信验证码"
          :rules="[{ required: true, message: '请填写短信验证码' }]"
        >
          <template #button>
            <div v-if="!timer" @click="!yzmLoading ? getCode() : ''">
              获取验证码
            </div>
            <van-count-down v-else :time="timer" @finish="timer = 0" />
          </template>
        </van-field>
        <van-button
          block
          color="#1989fa"
          loading-text="加载中..."
          :loading="loading"
          class="loginBtn"
          native-type="submit"
        >
          立即登录
        </van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
import { nanhangLogin, nanhangSendCaptcha } from '@/api/nanhang'
export default {
  data() {
    return {
      form: {
        phone: '',
        captchaCode: ''
      },
      loading: false,
      yzmLoading: false,
      timer: 0
    }
  },
  methods: {
    async getCode() {
      try {
        await this.$refs.loginForm.validate('phone')
      } catch (error) {
        return
      }
      try {
        this.yzmLoading = true
        await nanhangSendCaptcha({
          phone: this.form.phone
        })
        this.yzmLoading = false
        this.timer = 60000
      } catch (error) {
        this.yzmLoading = false
        console.log(error)
      }
    },
    async onSubmit() {
      try {
        this.loading = true
        const { data } = await nanhangLogin(this.form)
        this.loading = false
        sessionStorage.setItem('nanhangToken', data)
        this.$router.push('/nanhang/orderList')
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.nanhangLogin {
  min-height: 100vh;
  background: linear-gradient(180deg, #1989fa 0%, #e8f2ff 320px, #f7f8fa 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 20px 0px;
  box-sizing: border-box;
  justify-content: center;
  .logo {
    display: block;
    width: 260px;
    margin-bottom: 15%;
  }
  .loginCard {
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 16px;
    padding: 32px 20px 24px;
    box-sizing: border-box;
    box-shadow: 0 8px 24px rgba(25, 137, 250, 0.12);
    .title {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      color: #323233;
      text-align: center;
    }
    .subtitle {
      margin: 8px 0 24px;
      font-size: 13px;
      color: #969799;
      text-align: center;
    }
    .container {
      .van-cell {
        border-radius: 24px;
        margin-bottom: 16px;
        line-height: 30px;
        padding: 10px 22px;
        background: #f7f8fa;
      }
      :deep(.van-field__button) {
        color: #1989fa;
      }
      .loginBtn {
        margin-top: 8px;
        border-radius: 24px;
        font-size: 17px;
        height: 48px;
        line-height: 48px;
      }
    }
  }
}
</style>
